export const QUERY_KEY_EVENT = 'QUERY_KEY_EVENT'
